import { render, staticRenderFns } from "./PtCell.vue?vue&type=template&id=c1698252&scoped=true"
import script from "./PtCell.vue?vue&type=script&lang=js"
export * from "./PtCell.vue?vue&type=script&lang=js"
import style0 from "./PtCell.vue?vue&type=style&index=0&id=c1698252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1698252",
  null
  
)

export default component.exports